<template>
    <section
        class="w-[380px] bg-[var(--background-primary)] border border-[var(--background-btn)] text-white p-4 rounded-xl shadow-lg">
        <!-- Title -->
        <h2 class="text-lg font-semibold mb-4">Multi Country Tax</h2>

        <!-- Grid of country tax cards -->
        <div class="grid grid-cols-2 gap-3">
            <div v-for="(tax, index) in taxes" :key="index"
                class=" bg-[#11182C] flex flex-col gap-4 rounded-lg p-3 border border-gray-700">
                <div class="flex gap-2">
                    <!-- Flag -->
                    <NuxtImg :src="tax.flag" alt="flag" width="24" height="24" class=" rounded-full" loading="lazy" />

                    <p class="text-sm font-medium">{{ tax.country }}</p>

                </div>
                <div class="flex justify-between">
                    <p class="text-xs text-gray-400">{{ tax.type }}</p>
                    <p class="text-xs font-semibold">{{ tax.rate }}</p>
                </div>

            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const taxes = [
    {
        country: "USA",
        type: "Sales Tax",
        rate: "0% to 10%+",
        flag: "https://flagcdn.com/us.svg",
    },
    {
        country: "Spain",
        type: "VAT",
        rate: "20%",
        flag: "https://flagcdn.com/es.svg",
    },
    {
        country: "France",
        type: "TVA",
        rate: "20%",
        flag: "https://flagcdn.com/fr.svg",
    },
    {
        country: "Germany",
        type: "MwSt",
        rate: "10%",
        flag: "https://flagcdn.com/de.svg",
    },
];
</script>
